<template>
  <div class="PcNewsContent">
    <div class="setWidth titleImg">
      <img class="image" src="./img/PressCenter.png" alt="" />
    </div>
    <div class="title">公司新闻</div>
    <p class="divider"></p>
    <div class="PcNewsBox">
      <p
        class="fiveBoxTopRP"
        :class="{ onFiveBoxTopRP: ItemIndex === item.ID }"
        v-for="item in newsTitle"
        :key="item.ID"
        @click="getArticleApiIndex(item.ID)"
      >
        {{ item.Name }}
      </p>
    </div>
    <div class="newsList">
      <div
        class="newsItem"
        v-for="item in moreNewsList"
        :key="item.ID"
        @click="goNewsItem(item)"
      >
        <div class="PcNewsLeft">
          <img
            v-lazy="item.TitlePic"
            :key="item.TitlePic"
            class="fiveBoxBottomLImg"
          />
          <!-- <el-image :src='item.TitlePic' class="fiveBoxBottomLImg">
            <div slot="error" class="image-slot">
              <img class="fiveBoxBottomLImg" src="./img/presssix.png" alt="">
            </div>
          </el-image> -->
        </div>
        <div class="PcNewsRight">
          <p class="PcNewsRightTitle">{{ item.Title }}</p>
          <p class="PcNewsRightInfo">{{ item.Info }}</p>
          <p class="PcNewsRightTime">{{ item.AddTime | timeFormat }}</p>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <!-- <div   class="pagination">
      <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="4">
    </el-pagination>
    </div> -->
  </div>
</template>

<script>
// 获取新闻中心
import { getArticleApiIndex } from "@/api/news";
// 引入根路径
import request from "@/utils/request";
// 引入时间格式过滤
import { timeFormat } from "@/utils/myFilters";
export default {
  data() {
    return {
      moreNews: false, // 控制是否显示更多
      // newsTitle: [] // 新闻分类
      moreNewsList: [], // 更多新闻
      moreNewsListTitle: "", // 更多新闻标题
      headNews: [], // 头部新闻左
      headNewsL: [], // 头部新闻右
      headNewsShow: false, // 展位图
      ItemIndex: 7, // 新闻选中index
      total: 10
    };
  },
  filters: {
    timeFormat
  },

  mounted() {
    this.moreNews = true;
    // this.ItemIndex = this.$store.state.newsTitle[0].ID
    // this.newsTitle = this.$store.state.newsTitle
    // console.log('aaaaaaaaa')
    this.getArticleApiIndex(this.ItemIndex);
    // console.log(this.$store.state.newsTitle[0].ID, 'IDDD')
  },
  computed: {
    newsTitle() {
      return this.$store.state.newsTitle;
    }
  },
  methods: {
    // 返回新闻中心
    backNews(item) {
      // console.log(item, '11111111')
      this.moreNews = !this.moreNews;
      // console.log(this.moreNews)
      this.moreNewsListTitle = item.Name;
      // this.getArticleApiIndex({ TypeId: item.ID })
    },
    async getArticleApiIndex(id) {
      // console.log(id)
      this.ItemIndex = id;
      const res = await getArticleApiIndex({ TypeId: id });
      // console.log(res, 'xinwenzhongx')
      if (res.Msg === "获取成功") {
        this.moreNewsList = res.Data;
        this.moreNewsList.sort((a, b) => {
          return b.ID - a.ID;
        });
        this.total = this.moreNewsList.length;
        this.moreNewsList.forEach(item => {
          item.TitlePic = request.defaults.baseURL + item.TitlePic;
        });
      }
      // console.log(this.moreNewsList)
      // if (this.moreNewsList.length > 0) {
      //   this.headNews = this.moreNewsList.shift()
      //   // console.log(this.headNews)
      //   this.headNewsL = this.moreNewsList.splice(0, 4)
      //   // console.log(this.headNewsL, 'this.headNewsL')
      //   this.headNewsShow = false
      // } else {
      //   this.headNewsShow = true
      // }
    },
    goNewsItem(item) {
      // this.$router.push(newsItem)
      this.$router.push({ path: `/newsItemNew/${item.ID}` });
    }
  }
};
</script>

<style lang="scss" scoped>
$sun: 100/192;
.PcNewsContent {
  overflow: hidden;
}
.setWidth {
  margin-bottom: 50px * $sun;
  width: 100%;
  height: 460px * $sun;
  img {
    width: 100%;
    height: 100%;
  }
}
.title {
  margin: 0 auto;
  margin-top: 50px * $sun;
  margin-bottom: 20px * $sun;
  width: 1400px * $sun;
  font-size: 34px$sun;
  font-weight: bold;
  color: #343030;
  text-align: center;
}
.divider {
  width: 86px * $sun;
  height: 40px * $sun;
  margin: 0 auto;
  border-top: 4px * $sun solid #2380e1;
}
.PcNewsBox {
  margin: 0 auto;
  width: 436px * $sun;
  height: 43px * $sun;
  margin-bottom: 30px * $sun;
}
.fiveBoxTopRP {
  float: left;
  margin: 0;
  margin-left: 10px * $sun;
  margin-right: 10px * $sun;
  font-size: 16px * $sun;
  width: 124px * $sun;
  height: 43px * $sun;
  border: 2px * $sun solid #999999;
  border-radius: 4px * $sun;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  text-align: center;
  line-height: 40px * $sun;
  // background: #2380E1;
  cursor: pointer;
  font-weight: 500;
}
.onFiveBoxTopRP {
  background: #2380e1;
  color: #fff;
}
.newsList {
  width: 1400px * $sun;
  margin: 0 auto;
  overflow: hidden;
  margin-bottom: 40px * $sun;
}

.newsItem {
  margin-top: 20px * $sun;
  width: 1400px * $sun;
  height: 182px * $sun;
  border-bottom: 2px * $sun solid #dddddd;
  cursor: pointer;
  .PcNewsLeft {
    // width: 274px*$sun;
    // height: 130px*$sun;
    width: 143px * $sun;
    height: 94px * $sun;
    background: #999999;
    float: left;
    .fiveBoxBottomLImg {
      width: 143px * $sun;
      height: 94px * $sun;
      .fiveBoxBottomLImg {
        width: 143px * $sun;
        height: 94px * $sun;
      }
    }
  }
  .PcNewsRight {
    float: right;
    // width:1126px*$sun;
    width: 1250px * $sun;
    padding-left: 18px * $sun;
    p {
      margin: 0;
    }
    .PcNewsRightTitle {
      margin-bottom: 17px * $sun;
      height: 21px * $sun;
      font-size: 18px * $sun;
      font-weight: bold;
      color: #343030;
    }
    .PcNewsRightInfo {
      width: 999px * $sun;
      height: 52px * $sun;
      margin-bottom: 25px * $sun;
      font-size: 16px * $sun;
      font-weight: 500;
      color: #333333;
    }
    .PcNewsRightTime {
      height: 14px * $sun;
      font-size: 14px * $sun;
      font-weight: 500;
      color: #666666;
    }
  }
}
.newsItem:hover .PcNewsRightTitle,
.PcNewsRightInfo {
  color: #2380e1;
}
.newsItem:hover .PcNewsRightInfo {
  color: #2380e1;
}
.pagination {
  width: 500px * $sun;
  margin: 0 auto;
  margin-bottom: 50px * $sun;
}
::v-deep .el-pagination.is-background .el-pager li {
  //按钮列表
  background-color: #ffffff;
  width: 35px * $sun;
  height: 35px * $sun;
  font-size: 13px * $sun;
  color: #4d4f5c;
  border: 2px * $sun solid #e8e9ec;
  min-width: 35px * $sun;
  line-height: 35px * $sun;
}
::v-deep .el-pagination.is-background .btn-next {
  background-color: #ffffff;
  width: 35px * $sun;
  height: 35px * $sun;
  font-size: 13px * $sun;
  color: #4d4f5c;
  border: 2px * $sun solid #e8e9ec;
  min-width: 35px * $sun;
  line-height: 35px * $sun;
}
::v-deep .el-pagination.is-background .btn-prev {
  background-color: #ffffff;
  width: 35px * $sun;
  height: 35px * $sun;
  font-size: 13px * $sun;
  color: #4d4f5c;
  border: 2px * $sun solid #e8e9ec;
  min-width: 35px * $sun;
  line-height: 35px * $sun;
}
</style>
